import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { checkUrl } from '../deployment'

@Injectable({
  providedIn: 'root'
})
export class AdminService {
    constructor(private http: HttpClient, private router: Router) { }


    // (Requirement email , password*)
  login($data: any) {
    return this.http.post(checkUrl()+"/admin/login",$data)
    .pipe((response)=>{
        return response;
    })
  }

// (Requirement oldPassword * , newPassword * , confirmNewPassword *)
  changePassword($data:any){
    return this.http.post(checkUrl()+"/admin/change-password",$data)
    .pipe((response)=>{
          return response;
    })
  }

// Requirment ( Id *)
  details($data:any){
    return this.http.post(checkUrl()+"/admin/userDetails",$data)
    .pipe((response)=>{
          return response;
    })
  }

  //requirment (email)
  forgetPassword($data:any){
    return this.http.post(checkUrl()+"/user/forget-password",$data)
    .pipe((response)=>{
          return response;
    })
  }

  //requirment (email)
  verifyOTP($data:any){
    return this.http.post(checkUrl()+"/admin/verify-otp",$data)
    .pipe((response)=>{
          return response;
    })
  }

}
